import { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import {  LoadingSpinner, Modal } from "../../../components";
import "./styles.scss";
import SupportingMaterialService from "../../../services/SupportingMaterialService";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove} from "@dnd-kit/sortable";
import SortableCategoryItem from "./SortableCategoryItem";

const SupportingMaterialAdmin = () => {
    const [banner, setBanner] = useState<string | null>(null);
    const [isLoad, setIsLoad] = useState<Boolean>(false);
    const [category, setCategory] = useState<any[]>([]);
    const [file, setFile] = useState<File | null>(null);
    const [showModalCategory, setShowModalCategory] = useState(false);
    const [newCategory, setNewCategory] = useState({
        id:0,
        title: "",
        subTitle: "CLICK SOBRE OS ICONES PARA BAIXAR",
        description: "",
        isHighlight: false,
        isSeparator: false,
        Active: true
    });
    const navigate = useNavigate();
    const getBanner = async () => {
            setIsLoad(true);
         SupportingMaterialService.getBanner()
            .then((response: any) => {
                if (response) { setBanner(response.url); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }
    const getCategory = async () => {
            setIsLoad(true);
         SupportingMaterialService.getCategory()
            .then((response: any) => {
                if (response) { setCategory(response.sort((a: any, b: any) => a.ordem - b.ordem)); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }
    useEffect(() => {

        getBanner();
        getCategory();

    }, []);
    
    const sendBanner = async () => {
        if (!file) {
            toast.error("Selecione um arquivo!");
            return;
        }
        const input = document.getElementById("fileInput") as HTMLInputElement;
        if (!input || !input.files || input.files.length === 0) {
            toast.error("Selecione um arquivo!");
            return;
        }

        setIsLoad(true);
        try {
            const formData = new FormData();
            formData.append("FileInsert", file);

            await SupportingMaterialService.setBanner(formData).then(()=>{
                const campFile = document.getElementById("fileInput") as HTMLInputElement;
                if(campFile)
                    campFile.value = "";

                getBanner();
                setIsLoad(false);
                toast.success("Banner enviado com sucesso!");
            });
        } catch (error) {
            setIsLoad(false);
            toast.error("Erro ao enviar banner");
        }
    };
    const openModalAddCategory = () => {
        setNewCategory({ id:0, title: "", subTitle: "", description: "", isHighlight:false,Active:true, isSeparator:false });
        setShowModalCategory(true);
    };
    const saveCategory = async () => {
        if (!newCategory.title) {
            toast.error("Informe o título!");
            return;
        }

        try {
            setIsLoad(true);
            if((newCategory.id??0) >0){
                await SupportingMaterialService.updateCategory(newCategory);
                toast.success("Categoria alterada com sucesso!");
            }else{
                await SupportingMaterialService.setCategory(newCategory);
                toast.success("Categoria criada com sucesso!");
                setNewCategory({id:0, title: "", subTitle: "CLICK SOBRE OS ICONES PARA BAIXAR", description: "", isHighlight:false, isSeparator:false, Active:true });
            }
            setShowModalCategory(false);
            

            await getCategory();

        } catch (error) {
            toast.error("Erro ao salvar categoria");
        } finally {
            setIsLoad(false);
        }
    };
   const deleteCategory = async (id: number) => {
        Modal.question({
            title: "Confirmação",
            body: "Realmente deseja excluir essa categoria? Após essa ação não será possível recuperar.",
            callBack: async () => {
            try {
                setIsLoad(true);

                await SupportingMaterialService.deleteCategory(id);

                toast.success("Categoria excluída com sucesso!");
                await getCategory(); // 🔥 atualiza lista

            } catch {
                toast.error("Erro ao excluir");
            } finally {
                setIsLoad(false);
            }
            }
        });
    };
    const toggleActiveCategory = async (cat: any) => {
        try {
            setIsLoad(true);

            await SupportingMaterialService.updateCategory({
                ...cat,
                active: !cat.active
            });

            await getCategory(); // 🔥 recarrega lista

        } catch {
            toast.error("Erro ao atualizar status");
        } finally {
            setIsLoad(false);
        }
    };
    const openModalEditCategory = (cat:any) => {
        setNewCategory(cat);
        setShowModalCategory(true);
    };
    const openItemsCategory = (id:number) => {
        navigate(`../SupportingMaterialAdmin/SupportingMaterialSubCategoryAdmin/${id}`);
    };

    return (
        <>
            {
                isLoad === true &&
                <LoadingSpinner />
            }
            <div className="col-sm-6" style={{position:'relative', maxWidth: 600, borderBottom:'1px solid #dddddd', background:'#ffffff', padding:10, paddingBottom:20}}>
                <h4>Banner</h4>
                {
                    banner ? 
                        <img src={banner??undefined} alt="" style={{width:'100%', maxWidth:600, marginBottom:15}} />
                    :
                        <div onClick={()=> { document.getElementById("fileInput")?.click();}} style={{width:'100%', height: 200, backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom:15}}>
                            <span style={{color:'#999'}}>Nenhum banner encontrado, clique para adicionar!</span>
                        </div>
                }
                <input type="file" id="fileInput"
                    onChange={(e) => {
                        const selectedFile = e.target.files?.[0];
                        if (selectedFile) {
                        setFile(selectedFile);
                        }
                    }}
                />
                <button className="btn btn-success" style={{ alignSelf: "center", marginTop:10}} onClick={() => {sendBanner();}}>
                    <i className="mdi mdi-content-save" style={{fontSize: 15}} /> Salvar
                </button>
            </div>
            <div className="col-sm-6" style={{position:'relative', maxWidth: 600, borderBottom:'1px solid #dddddd', background:'#ffffff', padding:10, paddingBottom:20}}>
                <h4><span style={{display:'inline-block', marginTop:5}}>Categorias</span>
                    <button className="btn" style={{ alignSelf: "center", padding:0,  float:'right', background:'transparent'}} onClick={() => {openModalAddCategory();}}>
                        <i className="mdi mdi-plus-circle" style={{fontSize: 24, color:'#007733'}} />
                    </button>
                </h4>
                {showModalCategory && (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    }}>
                        
                        <div style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 8,
                        width: 400
                        }}>
                        {
                            (newCategory.id) ?
                                <h4>Editar</h4>
                            :
                                <h4>Nova Categoria</h4>
                        }

                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

                            <input
                            type="text"
                            placeholder="Título"
                            className="form-control"
                            value={newCategory.title}
                            onChange={(e) =>
                                setNewCategory({ ...newCategory, title: e.target.value })
                            }
                            />
                            {
                                (newCategory.isSeparator !== true) &&
                                <>
                                    <input
                                    type="text"
                                    placeholder="Subtítulo"
                                    className="form-control"
                                    value={newCategory.subTitle}
                                    onChange={(e) =>
                                        setNewCategory({ ...newCategory, subTitle: e.target.value })
                                    }
                                    />

                                    <textarea
                                    placeholder="Descrição"
                                    className="form-control"
                                    value={newCategory.description}
                                    onChange={(e) =>
                                        setNewCategory({ ...newCategory, description: e.target.value })
                                    }
                                    />
                                    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <input
                                        type="checkbox"
                                        checked={newCategory.isHighlight}
                                        onChange={(e) =>
                                        setNewCategory({
                                            ...newCategory,
                                            isHighlight: e.target.checked
                                        })
                                        }
                                    />
                                    Categoria em destaque
                                    </label>
                                </>
                            }
                            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                                type="checkbox"
                                checked={newCategory.isSeparator}
                                onChange={(e) =>
                                setNewCategory({
                                    ...newCategory,
                                    isSeparator: e.target.checked
                                })
                                }
                            />
                            É um separador
                            </label>

                        </div>

                        <div style={{ marginTop: 15, display: "flex", justifyContent: "flex-end", gap: 10 }}>
                            <button
                            className="btn btn-secondary"
                            onClick={() => setShowModalCategory(false)}
                            >
                            Cancelar
                            </button>

                            <button
                            className="btn btn-success"
                            onClick={async () => {
                                await saveCategory();
                                setShowModalCategory(false);
                            }}
                            >
                            Salvar
                            </button>
                        </div>

                        </div>
                    </div>
                )}
                <div>
                    <DndContext
                        collisionDetection={closestCenter}
                        onDragEnd={(event) => {
                            const { active, over } = event;

                            if (!over || active.id === over.id) return;

                            const oldIndex = category.findIndex(i => i.id === active.id);
                            const newIndex = category.findIndex(i => i.id === over.id);

                            const newItems = arrayMove(category, oldIndex, newIndex).map((item, index) => ({
                                ...item,
                                ordem: index + 1 // 🔥 atualiza ordem local
                            }));

                            setCategory(newItems);

                            const payload = newItems.map((item) => ({
                                id: item.id,
                                ordem: item.ordem
                            }));

                            SupportingMaterialService.updateCategoryOrder(payload);
                        }}
                    >
                        <SortableContext
                            items={category.map(i => i.id)}
                            strategy={verticalListSortingStrategy}
                        >
                           {category
                                .map((cat: any) => (
                                    <SortableCategoryItem
                                        key={cat.id}
                                        cat={cat}
                                        openModalEditCategory={openModalEditCategory}
                                        deleteCategory={deleteCategory}
                                        toggleActiveCategory={toggleActiveCategory}
                                        openItemsCategory={openItemsCategory}
                                    />
                            ))}
                        </SortableContext>
                    </DndContext>
                </div>
            </div>
            <Modal />
        </>
    );
};

export default SupportingMaterialAdmin;